import { axiosInstance } from "src/api/axiosInstance";
import type { ApiResponse } from "src/api/common/apiTypes";
import type {
  WarehouseListItem,
  WarehouseDetail,
  WarehouseListResponse,
  GetWarehouseListParams,
  WarehouseUpsertBody,
} from "src/types/warehouse";

// LIST
export const getWarehouseListApi = async (
  params: GetWarehouseListParams
): Promise<ApiResponse<WarehouseListResponse>> => {
  const res = await axiosInstance.get<ApiResponse<WarehouseListResponse>>(
    "/v1/admin/baseinfo/warehouse/list",
    {
      params: {
        warehouseName: params.warehouseName || undefined,
        inventoryType: params.inventoryType || undefined,
        isActive: typeof params.isActive === "boolean" ? params.isActive : undefined,
        page: params.page,
        size: params.size,
        order: params.order,
      },
    }
  );
  return res.data;
};

// DETAIL
export const getWarehouseApi = async (
  id: number
): Promise<ApiResponse<WarehouseDetail>> => {
  const res = await axiosInstance.get<ApiResponse<WarehouseDetail>>(
    `/v1/admin/baseinfo/warehouse/${id}`
  );
  return res.data;
};

// CREATE
export const createWarehouseApi = async (
  payload: WarehouseUpsertBody
): Promise<ApiResponse<WarehouseDetail>> => {
  const res = await axiosInstance.post<ApiResponse<WarehouseDetail>>(
    "/v1/admin/baseinfo/warehouse",
    payload
  );
  return res.data;
};

// UPDATE
export const updateWarehouseApi = async (
  id: number,
  payload: WarehouseUpsertBody
): Promise<ApiResponse<WarehouseDetail>> => {
  const res = await axiosInstance.put<ApiResponse<WarehouseDetail>>(
    `/v1/admin/baseinfo/warehouse/${id}`,
    payload
  );
  return res.data;
};

// DELETE
export const deleteWarehouseApi = async (id: number): Promise<ApiResponse<null>> => {
  const res = await axiosInstance.delete<ApiResponse<null>>(
    `/v1/admin/baseinfo/warehouse/${id}`
  );
  return res.data;
};

export type { WarehouseListItem, WarehouseDetail };
